import React, { useMemo } from 'react';
import { useLocation, useHistory } from 'react-router';
import HistoryOrdersList from './Components/HistoryOrdersList';
import styled from '@emotion/styled';
import useI18n from '~Translations';
import BackTopBar from '~ComponentsImproved/BackTopBar';
import HistoryOrder from './Components/HistoryOrder';
import OngoingCheque from './Components/OngoingCheque';

const PageWrapper = styled.div`
  background-color: var(--colorBlueGray1200);
  height: calc(100vh - 64px);
  display: flex;
  flex-flow: column nowrap;
  overflow: hidden;
`;

const Wrapper = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
`;

const ListWrapper = styled.div`
  width: 40%;
  overflow: hidden;
  box-sizing: border-box;
  padding-left: 16px;
  padding-bottom: 40px;
`;

const ContentWrapper = styled.div`
  flex: 1;
  padding: 24px 16px 40px;
  overflow: auto;
`;

const History = () => {
  const { i18n } = useI18n();
  const location = useLocation();
  const history = useHistory();

  // Extract the selected order ID from URL params
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const selectedOrderId = searchParams.get('orderId');
  const selectedChequeId = searchParams.get('chequeId');

  const onOrderClick = (orderId: string) => {
    const params = new URLSearchParams(location.search);
    params.set('orderId', orderId);
    params.delete('chequeId');
    // Use replace instead of push to update URL without adding to browser history
    history.replace({
      search: params.toString(),
    });
  };

  const onChequeClick = (chequeId: string) => {
    const params = new URLSearchParams(location.search);
    params.set('chequeId', chequeId);
    params.delete('orderId');
    // Use replace instead of push to update URL without adding to browser history
    history.replace({
      search: params.toString(),
    });
  };

  return (
    <div>
      <PageWrapper>
        <BackTopBar title={i18n('History.Title')} dark></BackTopBar>
        <Wrapper>
          <ListWrapper>
            <HistoryOrdersList onOrderClick={onOrderClick} onChequeClick={onChequeClick} />
          </ListWrapper>

          <ContentWrapper>
            {selectedOrderId && <HistoryOrder orderId={selectedOrderId} />}

            {selectedChequeId && <OngoingCheque chequeId={selectedChequeId} />}
          </ContentWrapper>
        </Wrapper>
      </PageWrapper>
    </div>
  );
};

export default History;
